/* eslint-disable no-param-reassign */
// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Container } from './PitDashboard.style';
import { ServerStatus } from './components';

type StateType = {
  pitNumber: number,
  time: number,
  lotNumbers: Array<number>,
};
export type StatePropsType = {
  stats: any,
};
export type DispatchPropsType = {
  fetchPitStatsRequest: Function,
  pitStatsReset: Function,
};
declare type Props = StatePropsType & DispatchPropsType;

class PitDashboard extends Component<Props & DispatchPropsType, StateType> {
  interval: IntervalID;

  constructor(props) {
    super(props);
    this.state = {
      time: Date.now(),
      lotNumbers: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 31, 32, 105, 201, 202, 203, 204, 205, 206,
        207, 208, 209, 210,
      ],
    };
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    const { pitStatsReset } = this.props;
    pitStatsReset();
  }

  fetchData = () => {
    const { time, pitNumber } = this.state;
    if ((Date.now() - time) / (5 * 60 * 1000) > 1) {
      window.location.reload(false);
    }
    const { fetchPitStatsRequest } = this.props;
    fetchPitStatsRequest(pitNumber);
  };

  handleChange = (e) => {
    const {
      target: { value },
    } = e;
    this.setState({ pitNumber: value }, this.fetchData);
    this.interval = setInterval(() => this.setState({}, this.fetchData), 20000);
  };

  showToast = (logs) => {
    const alertOptions = {
      position: 'bottom-right',
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
    };
    // eslint-disable-next-line array-callback-return
    logs.disrupt.map((log) => {
      toast.warn(`${log.machine.name} is disrupted`, alertOptions);
    });
    // eslint-disable-next-line array-callback-return
    logs.outage.map((log) => {
      toast.error(`${log.machine.name} is not reachable`, alertOptions);
    });
  };

  render() {
    const { stats } = this.props;
    const { lotNumbers, pitNumber } = this.state;
    return (
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid md={9} paddingLeft={1} paddingTop={1}>
              <Typography variant="h5" color="text.primary" gutterBottom>
                Pit Dashboard
              </Typography>
            </Grid>
            <Grid md={3} padding={2}>
              <select name="type" id="type" className="form-control" placeholder="Select type" onChange={this.handleChange}>
                <option defaultValue="na" defaultChecked="true">
                  Select Pit Number
                </option>
                {lotNumbers.map((lot) => (
                  <option key={lot} defaultValue={lot}>
                    {lot}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={1} md={12}>
            <Grid container item spacing={1} md={4}>
              <Grid md={12} padding={2}>
                <ServerStatus variant="info" records={pitNumber || 0} title="Pit Number" textVarient="h1" textAlign="center" />
              </Grid>
            </Grid>
            <Grid spacing={1} md={8}>
              <Grid container item spacing={1} md={12}>
                <Grid item md={6}>
                  <ServerStatus
                    link={`/logs/pit/1/${pitNumber}`}
                    variant="secondary"
                    records={stats.vehicleInsidePitToday}
                    // duration="1d"
                    disabledButton={!pitNumber}
                    title="Vehicles Inside Pit"
                  />
                </Grid>
                <Grid item md={6}>
                  <ServerStatus
                    link={`/logs/pit/2/${pitNumber}`}
                    variant="error"
                    records={stats.vehicleHeadingToPitToday}
                    duration="1d"
                    title="Vehicles heading towards this pit"
                    disabledButton={!pitNumber}
                  />
                </Grid>
              </Grid>
              <Grid container item spacing={1} md={12}>
                <Grid md={6}>
                  <ServerStatus
                    link={`/logs/pit/3/${pitNumber}`}
                    variant="warning"
                    records={stats.materialDispatchedFromPitToday}
                    duration="1d"
                    title="Material dispatched today from this pit (in MT)"
                    disabledButton={!pitNumber}
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    link={`/logs/pit/4/${pitNumber}`}
                    variant="success"
                    records={stats.materialDispatchedFromPitYesterday}
                    duration="1d"
                    title="Material Dispatched yesterday from this pit (in MT)"
                    disabledButton={!pitNumber}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    );
  }
}

export default withRouter(PitDashboard);
